import {TRouteId} from "../../index";

export namespace nsSitemap {
    export interface ISitemapLink {
        routeId: TRouteId
        children?: TSitemapLink[]
    }

    export type TSitemapLink = TRouteId | ISitemapLink;

    export const SitemapTree: TSitemapLink[] = [
        {
            routeId: 'myprofile',
            children: [
                'resetownpassword',
                'privacypolicy',
            ],
        },
        {
            routeId: 'userstart',
            children: [
                'usersearch',
                {
                    routeId: 'manualusersearch',
                    children: [
                        'wizardcreateuser',
                        'createmanualuser',
                        'uploadmanualusers',
                    ]
                },
                'apiusersearch',
                {
                    routeId: 'manualapiusersearch',
                    children: [
                        'createmanualapiuser',
                    ]
                }
            ]
        },
        {
            routeId: 'groupstart',
            children: [
                'groupsearch',
                {
                    routeId: 'manualgroupsearch',
                    children: [
                        'wizardcreategroup',
                        'createmanualgroup',
                        'uploadmanualgroups',
                    ]
                }
            ]
        },
        {
            routeId: 'departmentstart',
            children: [
                'departmenthierarchy',
                'departmentsearch',
                {
                    routeId: 'manualdepartmentsearch',
                    children: [
                        'createmanualdepartment',
                        'uploadmanualdepartments',
                    ]
                }
            ]
        },
        {
            routeId: 'rulesetsearch',
            children: ['createruleset'],
        },
        {
            routeId: 'sync',
            children: [
                'syncstatusv2',
                'syncexportqueue',
                'importhistorysearch',
                {
                    routeId: 'synctemplatesearch',
                    children: ['createsynctemplate'],
                },
                'syncintegrationtests',
            ]
        },
        {
            routeId: 'messageflowsearch',
            children: [
                'createmessageflow',
            ]
        },
        {
            routeId: 'systemaccesstart',
            children: [
                'systemaccessearch',
                'systempermissionsearch',
                'createsystemaccess',
            ]
        },
        'wizardpermissions',
        {
            routeId: 'ehub',
            children: [
                'availableforms',
                'formdatasearch',
                'formtemplatesearch'
            ]
        },
        {
            routeId: 'logstart',
            children: [
                'logauditsearch',
                'logsecuritysearch',
                'logerrorsearch',
            ]
        },
        {
            routeId: 'customerconfig',
            children: [
                'createcustomer',
                'editcustomer',
                {
                    routeId: 'customercommentsdetails',
                    children: [
                        'editcustomercomments',
                    ]
                },
            ]
        },
        'report',
        'systemfieldsdetails',
        {
            routeId: 'about',
            children: [
                'about_privacypolicy',
                'about_application',
            ]
        },
        'settings',
    ]
}
